import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router";

import NotRefWindowTitle from "./components/NotRefWindowTitle";
import {
  changeOrderNotRefUrl,
  createOrderNotRefUrl,
  NotRefOrderQueryParams,
  NotRefOrderSortField,
  previewChangeOrderUrl,
  previewOrderUrl
} from "./urls";
import CreateOrChangeNotRefContractView from "./views/createOrChangeNotRefContractView";
import PreviewOrderNotRef from "./views/PreviewOrder/PreviewOrderNotRef";

const NotRefContractComponent: React.FC<RouteComponentProps<any>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: NotRefOrderQueryParams = asSortParams(
    qs,
    NotRefOrderSortField,
    NotRefOrderSortField.itemNo
  );
  const isChangeFlow = location.pathname?.includes(changeOrderNotRefUrl);
  return (
    <>
      <NotRefWindowTitle isChangeFlow={isChangeFlow} />
      <CreateOrChangeNotRefContractView
        orderId={match.params.id}
        params={params}
        isChangeFlow={isChangeFlow}
      />
    </>
  );
};

const PreviewOrderView: React.FC<RouteComponentProps<any>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: NotRefOrderQueryParams = asSortParams(
    qs,
    NotRefOrderSortField,
    NotRefOrderSortField.itemNo
  );
  const isChangeFlow = location.pathname?.includes(changeOrderNotRefUrl);
  return (
    <PreviewOrderNotRef
      orderId={match.params.id}
      params={params}
      isChangeFlow={isChangeFlow}
    />
  );
};

const CreateOrderNotRefSection = () => (
  <Switch>
    <Route exact path={createOrderNotRefUrl} render={NotRefContractComponent} />
    <Route
      exact
      path={createOrderNotRefUrl + "/:id"}
      render={NotRefContractComponent}
    />
    <Route exact path={previewOrderUrl + "/:id"} render={PreviewOrderView} />
    <Route
      exact
      path={previewChangeOrderUrl + "/:id"}
      render={PreviewOrderView}
    />
    <Route exact path={changeOrderNotRefUrl} render={NotRefContractComponent} />
    <Route
      exact
      path={changeOrderNotRefUrl + "/:id"}
      key={changeOrderNotRefUrl}
      render={NotRefContractComponent}
    />
  </Switch>
);

export default CreateOrderNotRefSection;
